/**
 * Directive for the Edit Portal Page Downloadable Files section.
 * Do not change the directive name here as its used dynamically in the view to load multiple instances
 */
SUGApp.directive("sugFiles", function() {
    return({
        restrict: "A",
        templateUrl: "/view/tools/portals/dspSectionFiles.html",
        scope: {
            data: '=',
            section: '='
        },
        controller:
                ['$scope','$filter','$q','$timeout','$window','SUGUtilities','sugCacheFactory','errorService','settingService','globalService','portalService',
        function($scope , $filter , $q , $timeout , $window , SUGUtilities , sugCacheFactory , errorService , settingService , globalService , portalService)
        {
            // $scope refers to scope of this perticular directive instance.

            //init error service
            $scope.es = errorService.newInstance();
            $scope.es.init();

            /* Init vars */
            $scope.loaded = false;
            $scope.sectioncontent = {};     //parsed JSON string
            $scope.selectedFiles = [];
            $scope.sectiondata = {};
            $scope.selectedFilesFiltered = [];
            $scope.folders = [];
            $scope.folderContext = [""];
            /*
             * Crucial to keep this in an object to ensure protoypical inheritence. If we pass this as a primitive array,
             * we will lose the binding in the sug-advanced-breadcrumb directive.
             * Great explaination on angularjs scoping: https://stackoverflow.com/questions/15719558/isolated-scope-with-simple-angularjs-nested-directive
             */
            $scope.crumbObj = {
                crumbtrail: []
            };


            /* Form Elements */
            $scope.frmObj = {
                  searchFilter: ''
                , orderColumn:  ''
                , direction:    ''
                , numPerPage:   0
            };
            $scope.recordCount = 0;
            $scope.dateFormat = 'mm/dd/yyyy';



            /* Text Strings */
            $scope.strings = {
                  asc:              'ASC'
                , desc:             'DESC'
                , noData:           'There are no downloadable files.'
                , folderEmpty:      'There are no files available in this folder.'
                , noFilteredData:   'No data matched your filter criteria. Please try again.'
                , itemsPerPageInvalid: 'Items per page must be a number greater than 0.'
                , tips:   {
                      iconview:     'Show Icon View'
                    , listview:     'Show List View'
                }
                , headerTitle:      'Name'
                , headerSize:       'Size'
                , headerUpdated:    'Upload Date'
            };


            $scope.nofileswarning = {
                type:         'warning'
              , title:        ''
              , text:         'This section will not appear on the portal page unless there are files or folders assigned.<br>Edit this section to add files or folders.'
              , dismissable:  false
              , show:         true
              , noshadow:     true
            };


            //Set dynamic disable and processing vars so you only impact a specific directive instance
            $scope['frmDisableField'+$scope.section.id] = false;
            $scope['isProcessing'+$scope.section.id] = false;

            // Handler for Processing Status
            $scope.$on('isProcessingFiles', function (event, objProcessing) {
                //Verify the event has a valid object and is for this specific section instance
                if(    typeof objProcessing === "object"
                && typeof objProcessing.sectionId !== 'undefined'
                && typeof objProcessing.isprocessing !== 'undefined'
                && objProcessing.sectionId == $scope.section.id){
                    $scope['isProcessing'+$scope.section.id] = objProcessing.isprocessing;
                    disableForm(objProcessing.isprocessing);
                }
            });

            //manage disabling the form
            var disableForm = function (blnDisabled) {
                $scope['frmDisableField'+$scope.section.id] = blnDisabled;
            };


            /* Tooltip vars */
            $scope.popTrig = 'mouseenter';
            $scope.popPlacement = 'top';
            $scope.popDelay = 300;

            /************************
             SORTING and PAGINATION
            ************************/
            /* Pagination */
            $scope.pagination = {
                currentPage: 1,
                maxSize: 5,
                numPerPage: 5
            };

            /* Sort Options for Settings Popover */
            $scope.sortOptions = [
                { label: $scope.strings.asc , value: false },
                { label: $scope.strings.desc , value: true }
            ];

            /* Column Direct Sort */
            $scope.setSort = function (columnKey) {
                $scope.frmObj.orderColumn = columnKey;
                $scope.frmObj.direction = !$scope.frmObj.direction;
                $scope.glyphDir = $scope.frmObj.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
                filterSelectedFiles();
            };

            /* Apply Settings/Filter */
            var filterSelectedFiles = function() {
                if( $scope.loaded ){
                    // Prioritize sorting column(s) always breaking tie with 'clientfilename' column
                    // For sorts other than by name, sort is by type, reversed (folder, then file), then add the sub-sort(s)
                    // DIRECTION false: asc / true: desc
                    var orderBy = [$scope.frmObj.orderColumn];
                    if(orderBy[0] === 'clientfilename' || orderBy[0] === 'filename'){
                        orderBy = ['clientfilename'];
                    }
                    if(orderBy[0] === 'filetype' || orderBy[0] === 'type' ){
                        orderBy = ['sortpriority','filetype','clientfilename'];
                    }
                    if(orderBy[0] === 'filesizekb' || orderBy[0] === 'size'){
                        orderBy = ['sortpriority', 'filesizekb', 'clientfilename'];
                    }
                    if(orderBy[0] === 'datecreated' || orderBy[0] === 'uploaddate'){
                        orderBy = ['sortpriority','datecreated', 'clientfilename'];
                    }

                    // filter by breadcrumbs/foldercontext
                    var tmpSelectedFiles = [];

                    // Filter result to just the records in the current folder
                    for (var i in $scope.selectedFiles) {
                        if ($scope.selectedFiles.hasOwnProperty(i)) {
                            //manually add a filetype property to folder objects so they will sort correctly when filetype is chosen
                            if( $scope.selectedFiles[i].type === 'folder' ){ $scope.selectedFiles[i].filetype = ""; }

                            var foldersMatch = angular.equals($scope.selectedFiles[i].foldername, $scope.folderContext);

                            if (foldersMatch){
                                tmpSelectedFiles.push($scope.selectedFiles[i]);
                            }
                        }
                    }

                    if ($scope.frmObj.searchFilter !== '') {
                        $scope.selectedFilesFiltered = $filter('filter')(tmpSelectedFiles, $scope.searchFilteredSelectedFiles );
                        $scope.selectedFilesFiltered = $filter('orderBy')($scope.selectedFilesFiltered, orderBy, $scope.frmObj.direction);
                    } else {
                        $scope.selectedFilesFiltered = $filter('orderBy')(tmpSelectedFiles, orderBy, $scope.frmObj.direction);
                    }

                    $scope.recordCount = $scope.selectedFilesFiltered.length;

                    // Apply Pagination
                    if ($scope.selectedFilesFiltered.length && $scope.pagination.currentPage !== 1) {
                        var begin = ($scope.pagination.currentPage - 1) * parseInt($scope.pagination.numPerPage);
                        var end = begin + parseInt($scope.pagination.numPerPage);
                        $scope.selectedFilesFiltered = $scope.selectedFilesFiltered.slice(begin, end);

                        // If end up with no results, recursively step back until we get valid paged results
                        if (!$scope.selectedFilesFiltered.length && $scope.pagination.currentPage > 1) {
                            $scope.pagination.currentPage--;
                            filterSelectedFiles();
                        }
                    }

                    // Wait to calculate the item counts until after pagination to prevent calculating for folders that will not appear in the current view
                    calulateItemCounts();

                }
            };

            /* Prepare Settings/Filter */
            var prepareSettings = function () {
                $scope.settingID = 'settingID' in $scope.frmObj ? $scope.frmObj.settingID : 0;
                if (!('searchFilter' in $scope.frmObj)) {
                    $scope.frmObj.searchFilter = '';
                }
                if (!('orderColumn' in $scope.frmObj)) {
                    $scope.frmObj.orderColumn = 'clientfilename';
                }
                if (!('direction' in $scope.frmObj)) {
                    $scope.frmObj.direction = false;
                }
                if (!('numPerPage' in $scope.frmObj)) {
                    $scope.frmObj.numPerPage = 10;
                }
                $scope.glyphDir = $scope.frmObj.direction ? 'sugicon-arrow-down-thick' : 'sugicon-arrow-up-thick';
                $scope.pagination.numPerPage = $scope.frmObj.numPerPage;
            };


            /************************
             SEARCH FILTERS
            ************************/
            $scope.searchFilteredSelectedFiles = function(objSelectedSignup){
                if( !$scope.frmObj.searchFilter
                    || objSelectedSignup.clientfilename.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1
                    || (objSelectedSignup.type !== 'folder' && objSelectedSignup.filetype.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1)
                    || objSelectedSignup.datecreatedsearchable.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1
                    || (objSelectedSignup.type !== 'folder' && objSelectedSignup.filesizekb.toString().toLowerCase().indexOf( $scope.frmObj.searchFilter.toString().toLowerCase() ) > -1)
                    ){
                    return true;
                } else {
                    return false;
                }
            };

            // Determines if the search filter input should be displayed
            $scope.showSearchFilter = function(){
                return $scope.recordCount > $scope.frmObj.numPerPage || $scope.frmObj.searchFilter.length > 0;
            };



            /************************
             MANAGE DATA
            ************************/

            /**
             * Listen for the files save event from the slide out so you can update the instance view
             */
            $scope.$on('portal_savefiles', function (evt,val) {
                //if the event has a valid value and is for this specific section instance, then update view
                if(    typeof val === "object"
                    && typeof val.sectionId !== 'undefined'
                    && typeof val.filesData !== 'undefined'
                    && val.sectionId == $scope.section.id)
                {
                    // Update data models to trigger view changes
                    $scope.sectioncontent = angular.copy( val.sectioncontent );
                    $scope.filesData = angular.copy( val.filesData );

                    //update the files array
                    $scope.selectedFiles = angular.copy( $scope.filesData );
                    $scope.selectedFilesFiltered = angular.copy( $scope.selectedFiles );
                    $scope.recordCount = $scope.selectedFilesFiltered.length;

                    //Handle epoch dates without times (set to midnight) and adding searchable dates
                    addFormattedDates();

                    // Update Settings with SectionContent data
                    $scope.frmObj.orderColumn = ( typeof $scope.sectioncontent.sortby !== 'undefined') ? $scope.sectioncontent.sortby : 'clientfilename';
                    $scope.frmObj.direction = ( typeof $scope.sectioncontent.sortdir !== 'undefined') ? ( $scope.sectioncontent.sortdir == 'asc') ? false : true : false;
                    $scope.frmObj.numPerPage = ( typeof $scope.sectioncontent.perpage !== 'undefined') ? $scope.sectioncontent.perpage : 10;

                    $scope.crumbObj.crumbtrail = typeof $scope.sectioncontent.title !== 'undefined' && $scope.sectioncontent.title !== '' ? [{title:$scope.sectioncontent.title}] : [{title:"Downloadable Files"}];
                    $scope.folderContext = [""];

                    //slide out uses a different var name so handle that
                    if( $scope.frmObj.orderColumn == 'filename' ){  $scope.frmObj.orderColumn = 'clientfilename'; }
                    filterSelectedFiles();
                }
            });

            /**
             * Initilize the view
             */
            var init = function() {
                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessingFiles', { 'sectionId': $scope.section.id, 'isprocessing': true });

                parseData();
            };


            /**
             * Method loads the info for the section directive from main data model
             */
            var parseData = function(){
                //parse the sectioncontent and related details
                $scope.sectioncontent = JSON.parse( $scope.section.sectioncontent );
                $scope.crumbObj.crumbtrail = typeof $scope.sectioncontent.title !== 'undefined' && $scope.sectioncontent.title !== '' ? [{title:$scope.sectioncontent.title}] : [{title:"Downloadable Files"}];
                $scope.folderContext = [""];

                //get the creator's selected dateAndTZFormats from the portal data
                if( typeof $scope.data.portalInfo.portal.dateformats != 'undefined'){
                    var arrDF = $scope.data.portalInfo.portal.dateformats;
                    for (var i = 0, len = arrDF.length; i < len; i++) {
                        var val = arrDF[i];
                        if (val.selected) {
                            $scope.dateFormat = val.short.replace('mm', 'MM');
                            $scope.strings.dateFormat = val.short;
                            break;
                        }
                    }
                }

                //clear the grid filter
                $scope.frmObj.searchFilter = '';

                //load the files data
                loadData();
            };

            /**
             * Method loads the data from the service if parseData() yields no values
             */
            var loadData = function(){
                var deferred = $q.defer();

                $scope.frmObj = sugCacheFactory.get('frmObjFilesPreview',{});

                //use the sectioncontent to pre-set the Settings values before we prep them
                prepareSettings();

                portalService.getFilesSectionData_Public({
                                                    "owner": $scope.data.portalInfo.portal.memberid,
                                                    "portalID": $scope.data.portalInfo.portal.id,
                                                    "portalSectionID": $scope.section.id
                                                })
                    .then(function (response) {
                        if (SUGUtilities.ajaxResultInvalid(response.data)) {
                            //toggle spinner and form disable
                            SUGUtilities.broadCast('isProcessingFiles', { 'sectionId': $scope.section.id, 'isprocessing': false });

                            // invalid response, show error
                            $scope.es.setError('filessection', SUGUtilities.getAjaxResponseMessage(response));
                        } else {
                            //response was valid
                            var r = SUGUtilities.lowerCaseKeys( response.data );

                            if( r.success && Object.keys(r.data).length ){
                                $scope.selectedFiles = r.data.selectedfiles;
                                $scope.folders = r.data.folders;

                                filterSelectedFiles();

                            } else {
                                $scope.selectedFiles = [];
                                $scope.folders = [];
                            }

                            //data is loaded in the main controller, so clone it into some vars and fire off some functions here
                            $scope.selectedFilesFiltered = angular.copy( $scope.selectedFiles );
                            $scope.recordCount = $scope.selectedFilesFiltered.length;


                            // Update Settings with SectionContent data, since we don't save settings
                            $scope.frmObj.orderColumn = ( typeof $scope.sectioncontent.sortby !== 'undefined' && $scope.sectioncontent.sortby != 'filename') ? $scope.sectioncontent.sortby : 'clientfilename';
                            $scope.frmObj.direction = ( typeof $scope.sectioncontent.sortdir !== 'undefined') ? ( $scope.sectioncontent.sortdir == 'asc') ? false : true : false;
                            $scope.frmObj.numPerPage = ( typeof $scope.sectioncontent.perpage !== 'undefined') ? $scope.sectioncontent.perpage : 10;

                            $scope.loaded = true;
                            addFormattedDates();

                            // run the filter
                            filterSelectedFiles();

                            //toggle spinner and form disable
                            SUGUtilities.broadCast('isProcessingFiles', { 'sectionId': $scope.section.id, 'isprocessing': false });
                        }
                        deferred.resolve($scope.selectedFiles);
                    });

                return deferred.promise;
            };

            /**
             * Method updates the objects in the selectedfiles array with a new key that has a Local Date that can be used for formatting
             * If the regular epoch date is formatted, if its time is midnight, the date will appear one day behind
             * This function needs to run anytime the selectedfiles array is updated.
             */
            var addFormattedDates = function(){
                $scope.selectedFiles.forEach( function(item){
                    item.datecreatedparsed = SUGUtilities.utcToLocalDate( new Date( item.datecreated ) );
                    item.datecreatedsearchable = $filter('date')(item.datecreatedparsed, $scope.dateFormat);
                });
            };

            /**
             * method to download file attachment
             **/
            $scope.downloadFile = function(token){
                $window.location.href = '/index.cfm?go=s.downloadSignUpResource&eToken=' + token;
            };

            /************************
             SETTINGS GEAR
            ************************/
            $scope.strings.settings = {
                  settingsName:     'portals_section_preview_files'
                , settingsPopover:  'Settings'
                , sortBy:           'Sort By'
                , sortOrder:        'Sort Order'
                , sort_type:        'Type'
                , sort_name:        'Name'
                , sort_size:        'Size'
                , sort_date:        'Upload Date'
                , itemsPerPage:     'Items Per Page'
            };

            /* Dropdown Click Handler */
            $scope.dropDownClickEvent = function (e) {
                ( typeof e.target.clientfilename !== 'undefined' && e.target.clientfilename === $scope.strings.settings.saveSettings) ? saveMySettings() : e.stopPropagation() ;
            };

            /* Save Settings */
            var saveMySettings = function () {
                sugCacheFactory.set( 'frmObjFilesPreview', angular.copy($scope.frmObj) );
            };



            /************************
             DRILL DOWN
            ************************/

            /**
             * Updates the folderContext based on updates to the breadcrumb trail
             */
            $scope.changeCrumbPath = function () {
                // Reset folderContext to default
                $scope.folderContext = [""];
                // Loop over crumbtrail and append the folders to the folderContext

                if( $scope.crumbObj.crumbtrail.length > 1 ) {
                    for (var folder in $scope.crumbObj.crumbtrail) {
                        if( folder > 0 ) {
                            $scope.folderContext.push($scope.crumbObj.crumbtrail[folder].title);
                        }
                    }
                }

                // Reset pagination to page 1 when changing path
                $scope.pagination.currentPage = 1;
                // Reappy filtering
                filterSelectedFiles();
                return;
            };

            /**
             * Updates the crumbtrail and folderContext when the user clicks on a folder link to drill down into it
             * @param {Object} newFoldername - Name of the folder the user is drilling down into
             */
            $scope.changeFolder = function (newFoldername) {
                $scope.crumbObj.crumbtrail.push({title: newFoldername});
                $scope.folderContext.push(newFoldername);
                filterSelectedFiles();
                return;
            };

            //Calulate item counts
            var calulateItemCounts = function () {

                for (var i = 0; i < $scope.selectedFilesFiltered.length; i++) {
                    if ($scope.selectedFilesFiltered.hasOwnProperty(i)) {
                        if ($scope.selectedFilesFiltered[i].type === "folder") {
                            // Make a copy of the foldername from the display object to prevent the global folderContext from being corrupted
                            var localFolderContext = angular.copy($scope.selectedFilesFiltered[i].foldername);
                            localFolderContext.push($scope.selectedFilesFiltered[i].clientfilename);
                            var foldercontextForCount = localFolderContext;
                            $scope.selectedFilesFiltered[i].folderCount = getFolderCount(foldercontextForCount);
                        }
                    }
                }
            };

            // Calculate folder Counts
            var getFolderCount = function (folder) {
                var folderCount = 0;

                for (var i = 0; i < $scope.selectedFiles.length; i++) {
                    if ($scope.selectedFiles.hasOwnProperty(i)){
                        if (angular.equals($scope.selectedFiles[i].foldername, folder)) {
                            folderCount++;
                        }
                    }
                }

                return folderCount;
            };

            /**
             * Method scrolls to the top of the section when the pagination control is clicked
             * Originaly this was in the $watcher,m however that caused it to fire on page load
             * Now it is standalone and triggered by the pagination control's onClick event
             * @sectionid - Required - Valid id of the unique section triggering the click
             */
            $scope.setScroll = function (sectionid ){
                if( typeof sectionid != 'undefined' && sectionid == $scope.section.id ){
                    //scroll to the top of the section when paginated
                    var sectionContainer = document.getElementById("files" + $scope.section.id);
                    if( typeof sectionContainer !== 'undefined' && sectionContainer != null){
                        sectionContainer.scrollIntoView();
                    }
                }
            };



            /************************
             WATCHERS
            ************************/

            /* Watch Pagination - DO NOT PREFIX THESE VARS WITH $scope. (ex. $scope.pagination) */
            $scope.$watch('pagination.currentPage + pagination.numPerPage', function () {
                filterSelectedFiles();
            });

            /* Watch Form Object */
            $scope.$watchCollection('frmObj', function (nVal, oVal) {
                var newVal = angular.copy(nVal);
                var oldVal = angular.copy(oVal);

                // validate number per page (stop processing if empty or invalid since we must have it for proper filter/sort)
                if (!$scope.frmObj.numPerPage || $scope.frmObj.numPerPage.toString().trim() === '') {
                    return;
                } else if (!(angular.isNumber(~~$scope.frmObj.numPerPage) && isFinite(~~$scope.frmObj.numPerPage)) || ~~$scope.frmObj.numPerPage <= 0) {
                    SUGUtilities.showMagnificAlert($scope.strings.itemsPerPageInvalid, 'error', 'Cannot sort data', 'Sorry!');
                    $scope.frmObj.numPerPage = oldVal.numPerPage;
                    return;
                }

                // Prioritize sorting column(s) always breaking tie with 'clientfilename' column
                // If sort is by type (file or folder), then add a sub-sort of filetype (doc, xls, jpg, png, etc.)
                var orderBy = [$scope.frmObj.orderColumn];
                if(orderBy[0] == 'filename'){ orderBy = ['clientfilename']; } // slideout used filename so handle that
                if(orderBy[0] == 'filetype'){
                    if($scope.frmObj.direction){ orderBy.push('-type'); } else { orderBy.push('type'); }
                }
                if(orderBy[0] !== 'clientfilename'){
                    if($scope.frmObj.direction){ orderBy.push('-clientfilename'); } else { orderBy.push('clientfilename'); }
                }

                // Apply Filter - Filter through the data Array, NOT the filtered data
                $scope.selectedFilesFiltered = $filter('orderBy')($scope.selectedFiles, orderBy, $scope.frmObj.direction);
                /* Update Settings in Factory */
                sugCacheFactory.set( 'frmObjFilesPreview', angular.copy($scope.frmObj) );
                prepareSettings();

                // Apply Search Filter if Present - Filter through the data Array, NOT the filtered data
                if (newVal.searchFilter != oldVal.searchFilter) {
                    $scope.selectedFilesFiltered = $filter('filter')($scope.selectedFiles, $scope.searchFilteredSelectedFiles );
                    $scope.selectedFilesFiltered = $filter('orderBy')($scope.selectedFilesFiltered, orderBy, $scope.frmObj.direction);
                    $scope.recordCount = $scope.selectedFilesFiltered.length;
                } else {
                    filterSelectedFiles();
                }
            });


            init();

        }] // end controller
    }); // END return
});
